import { render } from "./BaseDialog.vue?vue&type=template&id=381b07da&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=381b07da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-381b07da"

export default script